
const dashboardRoutes = [
    {
        path:'index',
        name:'dashboard-index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/dashboard/index.vue')
    },
    
]
export default dashboardRoutes